// Romanian translations
export const ro: Record<string, string> = {
  'menu.dashboard': 'Tablou de bord',
  'menu.orderNew': 'Înregistrare produs',
  'menu.customers': 'Clienți',
  'menu.products': 'Produse',
  'menu.users': 'Utilizatori',
  'menu.settings': 'Setări',
  'menu.logout': 'Deconectare',
  'dashboard.title': 'Tablou de bord',
  'dashboard.todaySales': 'Vânzări astăzi',
  'dashboard.totalOrders': 'Total comenzi',
  'dashboard.newOrder': 'Comandă nouă',
  'dashboard.newCustomer': 'Client nou',
  'order.title': 'Comandă nouă',
  'order.customer': 'Client',
  'order.products': 'Produse',
  'order.quantity': 'Cantitate',
  'order.price': 'Preț',
  'order.total': 'Total',
  'order.payment': 'Plată',
  'order.cash': 'Numerar',
  'order.card': 'Card',
  'users.title': 'Utilizatori',
  'users.name': 'Nume',
  'users.email': 'Email',
  'users.role': 'Rol',
  'users.edit': 'Editează',
  'users.delete': 'Șterge',
  'common.yes': 'Da',
  'common.no': 'Nu',
  'common.cancel': 'Anulează',
  'common.save': 'Salvează',
  'common.search': 'Căutare',
  'common.loading': 'Se încarcă...',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Autentificare',
  'login.enterPin': 'Introduceți PIN',
  'login.welcome': '&X',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.title': 'Înregistrare',
  'signup.createAccount': 'Creează cont',
  'signup.email': 'Email',
  'signup.phone': 'Telefon',
  'menu.reportsAndAccounting': 'Rapoarte și contabilitate',
  'menu.systemAndCommunication': 'Sistem și comunicare',
};
